import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { useTranslate } from 'src/localization/Trns'

type MccGasIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccGasIcon(props: MccGasIconProps) {
  const translate = useTranslate()
  const { className = '', ['aria-label']: ariaLabel, ...rest } = props
  return (
    <svg
      className={cn('MccGasIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel ?? translate('Gas')}
      {...rest}
    >
      <path
        d="M1 14.6666H9M1.66667 5.99992H8.33333M8.33333 14.6666V2.66659C8.33333 2.31296 8.19286 1.97382 7.94281 1.72378C7.69276 1.47373 7.35362 1.33325 7 1.33325H3C2.64638 1.33325 2.30724 1.47373 2.05719 1.72378C1.80714 1.97382 1.66667 2.31296 1.66667 2.66659V14.6666M8.33333 8.66659H9.66667C10.0203 8.66659 10.3594 8.80706 10.6095 9.05711C10.8595 9.30716 11 9.6463 11 9.99992V11.3333C11 11.6869 11.1405 12.026 11.3905 12.2761C11.6406 12.5261 11.9797 12.6666 12.3333 12.6666C12.687 12.6666 13.0261 12.5261 13.2761 12.2761C13.5262 12.026 13.6667 11.6869 13.6667 11.3333V6.55325C13.6668 6.37731 13.6321 6.20308 13.5646 6.04061C13.4971 5.87813 13.3981 5.73062 13.2733 5.60659L11 3.33325"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
